import PageWrapper from 'components/utils/PageWrapper';
import Environment from 'pages/Environment';

export const environmentRoutes = {
    path: '/environment',
    element: (
        <PageWrapper titleId="common_environment">
            <Environment />
        </PageWrapper>
    ),
};
